<template>
    <div class="wrap">
      <div class="record-header">
        <router-link :to="'/'">立即查册</router-link>
        <router-link :to="'record'">过往查册记录</router-link>
      </div>
      <div class="record-content" :style="{minHeight:winHeight-80+'px'}">
        <div>
          <ul v-for="(item , i) in dataInfo">
            <li>
              <span><b>区</b>域：</span>
              <p>{{item.bquyu}}</p>
            </li>
            <li>
              <span><b>姓</b>名：</span>
              <p>{{item.bchanquanxm}}</p>
            </li>
            <li>
              <span>物业地址：</span>
              <p>{{item.bwuyedz}}</p>
            </li>
            <li>
              <span>房产证号：</span>
              <p>{{item.bchanchangzh}}</p>
            </li>
            <li>
              <span>字号类型：</span>
              <p>{{item.bzihaolx}}</p>
            </li>
            <li>
              <span>房产证复印件：</span>
              <p><img :src="item.bfuyinj" alt=""></p>
            </li>
            <li class="time">
              查册时间：{{item.addtime}}
            </li>
            <li class="infoBottom" >
              <p class="desc" v-if="parseInt(item.bchazhi)">取回查册纸</p>
              <p class="desc" v-else="parseInt(item.bchazhi)">查册结果已微信回复</p>
              <ul class="infoBottomList" v-show="parseInt(item.bchazhi)">
                <li >
                  <span>收件人：</span>
                  <p>{{item.bshoujianr}}</p>
                </li>
                <li>
                  <span>联系电话：</span>
                  <p>{{item.bdianhua}}</p>
                </li>
                <li>
                  <span>收件地址：</span>
                  <p>{{item.bdizhi}}</p>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="findNot" v-show="!dataInfo">
          <img src="../../img/findNot.png" alt="">
        </div>
      </div>
      <footerDiv></footerDiv>
    </div>

</template>

<script>
  import axios from 'axios'
  import footerDiv from '../component/footer'
  export default {
    data () {
      return {
        dataInfo:null,
        winHeight:window.screen.height,
      }
    },
    created: function () {
      var that = this
      $.post('ziyu.php?Action=listbook',
        {
          userUserID:window.localStorage.userUserID
        },
        function(data) {
          if(JSON.parse(data).length){
            that.dataInfo = JSON.parse(data)
            that.dataInfo.sort(that.compare('ID'))
            that.dataInfo.reverse()
            console.log(that.dataInfo)
          }
        })

    },
    computed:{
    },
    components: {
      footerDiv
    },
    methods: {
      compare (obj) {
        return (a,b) => {
          var val1 = a[obj]
          var val2 = b[obj]
          return val1 - val2
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
    @import "../reset"
    @import "./record"
</style>



// WEBPACK FOOTER //
// src/components/record/record.vue